import { extensionService } from './store/dataservice';
import {
  chartActions,
  chartService,
  infoActions,
  messageService,
  exportService,
  importService,
  feasibilityService,
  searchService,
  identityService,
  selectorsService,
  hierarchyNodeService,
  resourceService,
  analyticsService,
  exportActions,
  importActions,
  identityActions,
  siteSettingsActions,
  viewSettingsActions,
  searchActions,
  detailedSearchActions,
  resourceActions,
  settingsActions,
  hierarchyNodeActions,
  repositoryActions,
  selectorActions,
  configuratorActions,
  configuratorService,
  singleActionService,
  priceService,
  priceActions,
  helpImagesActions,
  analyticsActions,
  stockActions,
  stockService,
  superCodeActions,
  superCodeService,
  apttusActions,
  apttusService,
  feasibilityActions} from './services';

function configureRepository( entityName, service ) {
  extensionService.add(
    repositoryActions( entityName ).GET,
    service.get,
    null,
    action => [action.data]
  );
  extensionService.add(
    repositoryActions( entityName ).RETRIEVE,
    service.post,
    null,
    action => [action.data]
  );
  extensionService.add(
    repositoryActions( entityName ).DELETE,
    service.remove,
    null,
    action => [action.data]
  );
  extensionService.add(
    repositoryActions( entityName ).PUT,
    service.add,
    null,
    action => [action.data]
  );
}

/*
 * Register your extensions that should be used throughout the portal here
 * Actions that would be removed at a later time can be added in there appropriate sections
 */
extensionService.add( resourceActions.GET, resourceService.get );

extensionService.add( searchActions.GETPRODUCTS, searchService.get );

extensionService.add( exportActions.GET, exportService.get );

extensionService.add( exportActions.EXPORT, exportService.downloadExport );
extensionService.add( exportActions.CUSTOMEXPORT, exportService.customExport );

extensionService.add( importActions.IMPORT, importService.importExcel );
extensionService.add( importActions.VALIDATE, importService.validate );

extensionService.add( feasibilityActions.LOAD, feasibilityService.fetchFeasibilityValues );
extensionService.add( feasibilityActions.VALIDATE, feasibilityService.validateITCTValue );
extensionService.add( feasibilityActions.GETRESULT, feasibilityService.getITCTResult );
extensionService.add( feasibilityActions.GETCONFIGURATORID, feasibilityService.getConfiguratorId );

extensionService.add( chartActions.GET, chartService.get );

extensionService.add( 
  repositoryActions( 'orderCodes' ).RETRIEVE, 
  singleActionService( repositoryActions( 'orderCodes' ),'ordercodeprovider', 'RETRIEVED', 'items' ).get 
);

extensionService.add( 
  siteSettingsActions.GET, 
  singleActionService( siteSettingsActions, 'settings' ).get,
  [
    /*{ type: siteSettingsActions.GET },*/
    { type: hierarchyNodeActions.GET }, 
    { type: infoActions.GET }, 
    { type: viewSettingsActions.GET }, 
    { type: resourceActions.GET }, 
    { type: repositoryActions( 'selector' ).RETRIEVE }, 
    { type: selectorActions.INIT }, 
    { type: settingsActions.GET }, 
    { type: exportActions.GET }, 
    { type: helpImagesActions.GET },
    { type: repositoryActions( 'orderCodes' ).RETRIEVE }
  ]
);

extensionService.add( viewSettingsActions.GET, singleActionService( viewSettingsActions, 'viewSettings' ).get );

extensionService.add( infoActions.GET, singleActionService( infoActions, 'info' ).get );

extensionService.add(
  identityActions.GET,
  identityService.get, 
  null, 
  action => [action.cId],
  null,
  true
);

extensionService.add( hierarchyNodeActions.GET, hierarchyNodeService.get );

extensionService.add( repositoryActions( 'selector' ).RETRIEVE, selectorsService.get );

extensionService.add(
  configuratorActions.ASSIGN,
  configuratorService.assignValue,
  null,
  ( { content } ) => [content.template, content.key, content.value]
);

extensionService.add(
  configuratorActions.REMOVE,
  configuratorService.removeValue,
  null,
  ( { content } ) => [content.template, content.key, content.value]
);

extensionService.add(
  configuratorActions.RESETGROUP,
  configuratorService.resetGroup,
  null,
  ( { content } ) => [content.template, content.group]
);

extensionService.add(
  configuratorActions.FROMTEMPLATE,
  configuratorService.fromConfigured,
  null,
  ( { content } ) => [content.template, content.assignments]
);

extensionService.add(
  configuratorActions.RESET,
  configuratorService.fromTemplate,
  null,
  ( { product, modelToLoad, filterGroups, assignments, additionalVariants } ) => [product, modelToLoad, filterGroups, assignments, additionalVariants]
);

extensionService.add(
  configuratorActions.LOADCOMPLEX,
  configuratorService.fromComplexTemplate,
  null,
  ( { product, modelToLoad } ) => [{ product, modelToLoad }]
);

extensionService.add(
  priceActions.RETRIEVE,
  priceService.getPrices,
  null,
  ( { lineItems } ) => [lineItems]
);

extensionService.add(
  analyticsActions.EVENT,
  analyticsService.sendEvent,
);

extensionService.add(
  analyticsActions.PAGEVIEW,
  analyticsService.sendPageView,
);

extensionService.add(
  analyticsActions.INIT,
  analyticsService.initializeGA,
);

extensionService.add(
  analyticsActions.INITCOMMON,
  analyticsService.initializeGACommon,
);

extensionService.add(
  analyticsActions.SET,
  analyticsService.set
)

extensionService.add( helpImagesActions.GET, singleActionService( helpImagesActions, 'filterImages' ).get );

extensionService.add(
  stockActions.RETRIEVE,
  stockService.getStocks,
  null,
  ( { products, hasStockFilter } ) => [{ products, hasStockFilter }]
)
configureRepository( 'message', messageService );
extensionService.add(superCodeActions.CREATE, superCodeService.create);

extensionService.add(superCodeActions.IDENTIFY, superCodeService.identify);

extensionService.add(superCodeActions.SAVETOSAP, superCodeService.saveToSap);

extensionService.add(
  apttusActions.SAVE,
  apttusService.save,
);
